var makeString = require('./helper/makeString');

module.exports = function chars(str) {
  return makeString(str).split('');
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/underscore.string/chars.js
// module id = 158
// module chunks = 0